import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api, setAuthToken } from "../api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(localStorage.getItem("tecparts-token"));
  const [user, setUser] = useState(() => JSON.parse(localStorage.getItem("tecparts-user") || "null"));
  const [loading, setLoading] = useState(Boolean(token));

  useEffect(() => {
    setAuthToken(token);
    if (!token) { setLoading(false); return; }
    api.get("/auth/me").then(({ data }) => {
      setUser(data); localStorage.setItem("tecparts-user", JSON.stringify(data));
    }).catch(() => logout()).finally(() => setLoading(false));
  }, [token]);

  useEffect(() => {
    document.body.classList.toggle("luisa-style", user?.theme_style === "luisa");
    document.body.classList.toggle("standard-style", !user || user?.theme_style !== "luisa");
  }, [user]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("tecparts-token", data.token);
    localStorage.setItem("tecparts-user", JSON.stringify(data.user));
    setToken(data.token); setUser(data.user); setAuthToken(data.token);
    return data.user;
  };

  const logout = () => {
    api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("tecparts-token"); localStorage.removeItem("tecparts-user");
    setToken(null); setUser(null); setAuthToken(null);
  };

  const updateUser = (nextUser) => {
    setUser(nextUser);
    localStorage.setItem("tecparts-user", JSON.stringify(nextUser));
  };

  const value = useMemo(() => ({ token, user, loading, login, logout, updateUser, isAdmin: user?.role === "admin" }), [token, user, loading]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);